import { RiDeleteBin6Line } from "react-icons/ri";
import { GoPlus } from "react-icons/go";
import Form from '../../molecules/Form';
import Field from '../Field';
import Label from '../../molecules/Label';
import Button from '../../molecules/Button';
import Switch from "../Switch";
import SmallEditor from "./SmallEditor";
import { languageOptions } from "../../Constant";
import { personalizationOptions, toneOptions, emailLengthOptions } from "./offerFormConfig";

export const CompanyIdentityFields = ({ hideWebsite = false, hideCompany = false }) => {
    if (hideCompany && hideWebsite) return null;
    return (
    <div className="input-flex input-box">
        {!hideCompany && (
            <Form.Item
                label="Company Name"
                type="text"
                name="user_company"
                placeholder="e.g. Acme Outreach"
                inputSm
                noMargin
                rules={[
                    {
                        required: true,
                        message: 'Company Name is required',
                    },
                ]}>
                <Field />
            </Form.Item>
        )}
        {!hideWebsite && (
            <Form.Item
                label="Website URL"
                type="text"
                name="website_url"
                placeholder="https://yourcompany.com/"
                inputSm
                noMargin
                rules={[
                    {
                        required: true,
                        message: 'Website URL is required',
                    },
                ]}>
                <Field />
            </Form.Item>
        )}
    </div>
    );
};

export const OfferDetailsFields = ({ offerForm }) => {
    const { proofPoints, setProofPoints, features, setFeatures, goals, setGoals, handleAdd, handleRemove, updateItem } = offerForm;
    return (
        <>
            <div className="input-box">
                <Form.Item
                    label="What does your company do?"
                    type="textarea"
                    name="company_details"
                    placeholder="Briefly describe what you help businesses achieve."
                    inputSm
                    rules={[
                        {
                            required: true,
                            message: 'Company Details are required',
                        },
                    ]}>
                    <Field />
                </Form.Item>
                <Form.Item
                    label="What are you promoting in this campaign?"
                    type="textarea"
                    name="promoting_in_campaign"
                    placeholder="e.g. AI-powered cold outreach for B2B SaaS companies."
                    inputSm
                    rules={[
                        {
                            required: true,
                            message: 'Required',
                        },
                    ]}>
                    <Field />
                </Form.Item>
                <span className="section-heading">Proof Point</span>
                {proofPoints.map((item) => (
                    <div className="input-flex margin-bottom" key={item.id}>
                        <Form.Item
                            type="text"
                            name={`proof_point_${item.id}`}
                            placeholder="e.g. Email warm-up automation"
                            inputSm
                            noMargin
                            value={item.value}
                            onChange={(e) => updateItem(setProofPoints, item.id, { value: e.target.value })}
                            autoComplete={`proof-point-${item.id}`}
                        >
                            <Field />
                        </Form.Item>
                        {proofPoints.length > 1 && (
                            <button type="button" className="icon-holder delete" onClick={() => handleRemove(setProofPoints, item.id)}>
                                <RiDeleteBin6Line color="var(--danger)" size={20} />
                            </button>
                        )}
                    </div>
                ))}
                <Button variant="secondary" type="button" rounded onClick={() => handleAdd(setProofPoints)}><GoPlus size={20} />
                    Add Proof Point</Button>
            </div>
            <div className="input-box">
                <span className="section-heading">Core Features <span className="sub-heading">( List factual features, not benefits )</span></span>
                {features.map((item) => (
                    <div className="input-box" key={item.id}>
                        <Field
                            label="Pain Point"
                            type="text"
                            name={`feature_pain_point_${item.id}`}
                            placeholder="What Pain Points do you costumers experience?"
                            inputSm
                            value={item.pain_point}
                            onChange={(e) => updateItem(setFeatures, item.id, { pain_point: e.target.value })}
                        />
                        <Field
                            label="Solution"
                            type="text"
                            name={`feature_solution_${item.id}`}
                            placeholder="What is the solution to this pain point?"
                            inputSm
                            value={item.solution}
                            onChange={(e) => updateItem(setFeatures, item.id, { solution: e.target.value })}
                        />
                        <div className="btn-wrapper">
                            {features.length > 1 && (
                                <Button className="delete-btn" width="100px" sm variant="outline" type="button" onClick={() => handleRemove(setFeatures, item.id)}>
                                    <RiDeleteBin6Line size={18} />
                                    Delete
                                </Button>
                            )}
                        </div>
                    </div>
                ))}
                <Button variant="secondary" type="button" rounded onClick={() => handleAdd(setFeatures, { pain_point: '', solution: '' })}><GoPlus size={20} />
                    Add Feature</Button>
            </div>
            <div className="input-box">
                <span className="section-heading">What is your customers trying to achieve?</span>
                {goals.map((item) => (
                    <div className="input-flex margin-bottom" key={item.id}>
                        <Field
                            type="text"
                            name={`goal_${item.id}`}
                            placeholder="Customer goal"
                            inputSm
                            noMargin
                            value={item.value}
                            onChange={(e) => updateItem(setGoals, item.id, { value: e.target.value })}
                            autoComplete={`goal-${item.id}`}
                        />
                        {goals.length > 1 && (
                            <button type="button" className="icon-holder delete" onClick={() => handleRemove(setGoals, item.id)}>
                                <RiDeleteBin6Line color="var(--danger)" size={20} />
                            </button>
                        )}
                    </div>
                ))}
                <Button variant="secondary" type="button" rounded onClick={() => handleAdd(setGoals)}><GoPlus size={20} />
                    Add Goal</Button>
            </div>
        </>
    );
};

export const EmailLengthSelector = ({ activeTab, setActiveTab }) => (
    <div className="input-box">
        <span className="section-heading">Email Length</span>
        <div className="tabs-btns">
            {emailLengthOptions.map((option) => (
                <button
                    key={option.value}
                    type="button"
                    className={`tabBtn ${activeTab === option.value ? 'active' : ''}`}
                    onClick={() => setActiveTab(option.value)}>
                    <div className="btn-content">
                        <div className="text-box">
                            <span className="heading">{option.label}</span>
                            <span className="subtitle">Words</span>
                        </div>
                        <span className="ico-tick" />
                    </div>
                </button>
            ))}
        </div>
    </div>
);

export const PersonalizationFields = () => (
    <div className="input-box">
        <span className="section-heading">Personalization Options</span>
        {personalizationOptions.map((option) => (
            <div className="input-box personalization-row" key={option.name}>
                <div className="icon-box"> <img src={option.icon} alt={option.heading} /></div>
                <div className="text-box">
                    <span className="heading">{option.heading}</span>
                    <span className="subtitle">Description</span>
                </div>
                <Form.Item name={option.name} noMargin>
                    <Switch />
                </Form.Item>
            </div>
        ))}
    </div>
);

export const OutreachPreferenceFields = ({ offerForm, hideCoachingPoints = false }) => {
    const {
        callToActions, setCallToActions,
        allowedGreetings, setAllowedGreetings,
        coachingPoints, setCoachingPoints,
        handleAdd, handleRemove, updateItem,
    } = offerForm;
    return (
        <>
            <div className="input-box">
                <span className="section-heading">Call To Action</span>
                {callToActions.map((item) => (
                    <div className="greetings-row" key={item.id}>
                        <SmallEditor
                            onlyLink
                            value={item.value}
                            onChange={(e) =>
                                updateItem(setCallToActions, item.id, {
                                    value: e.target.value,
                                })
                            }
                        />
                        <div className="btn-wrapper">
                            {callToActions.length > 1 && (
                                <button type="button" className="icon-holder delete" onClick={() => handleRemove(setCallToActions, item.id)}>
                                    <RiDeleteBin6Line color="var(--danger)" size={20} />
                                </button>
                            )}
                        </div>
                    </div>
                ))}
                <Button variant="secondary" type="button" rounded onClick={() => handleAdd(setCallToActions)}><GoPlus size={20} />
                    Add CTA</Button>
            </div>
            <div className="input-box">
                <Form.Item
                    label="Tone"
                    type="select"
                    name="select_tone_from_dropdown"
                    placeholder="Select tone from dropdown"
                    options={toneOptions}
                    selectSm
                    rules={[
                        {
                            required: true,
                            message: 'Tone is required',
                        },
                    ]}
                >
                    <Field />
                </Form.Item>
                <Form.Item
                    label="Language"
                    type="select"
                    name="language_from_dropdown"
                    placeholder="Select language from dropdown"
                    options={languageOptions}
                    selectSm
                    rules={[
                        {
                            required: true,
                            message: 'Language is required',
                        },
                    ]}
                >
                    <Field />
                </Form.Item>
                <Label required>Allowed Greetings</Label>
                {allowedGreetings.map((item) => (
                    <div className="greetings-row" key={item.id}>
                        <SmallEditor
                            onlyVariable
                            value={item.value}
                            onChange={(e) =>
                                updateItem(setAllowedGreetings, item.id, {
                                    value: e.target.value,
                                })
                            }
                        />

                        {allowedGreetings.length > 1 && (
                            <button type="button" className="icon-holder delete" onClick={() => handleRemove(setAllowedGreetings, item.id)}>
                                <RiDeleteBin6Line color="var(--danger)" size={20} />
                            </button>
                        )}
                    </div>
                ))}
                <Button variant="secondary" type="button" className="greeting-add-btn" rounded onClick={() => handleAdd(setAllowedGreetings)}><GoPlus size={20} />
                    Add Greeting</Button>
                {!hideCoachingPoints && (
                    <>
                        <Label>Coaching Points</Label>
                        {coachingPoints.map((item) => (
                            <div className="input-flex margin-bottom" key={item.id}>
                                <Field
                                    type="text"
                                    name={`coaching_point_${item.id}`}
                                    placeholder="Enter coaching point"
                                    inputSm
                                    noMargin
                                    value={item.value}
                                    onChange={(e) => updateItem(setCoachingPoints, item.id, { value: e.target.value })}
                                    autoComplete={`coaching-point-${item.id}`}
                                />
                                {coachingPoints.length > 1 && (
                                    <button type="button" className="icon-holder delete" onClick={() => handleRemove(setCoachingPoints, item.id)}>
                                        <RiDeleteBin6Line color="var(--danger)" size={20} />
                                    </button>
                                )}
                            </div>
                        ))}
                        <Button variant="secondary" type="button" className="add-coaching-point-btn" rounded onClick={() => handleAdd(setCoachingPoints)}><GoPlus size={20} />
                            Add Coaching Point</Button>
                    </>
                )}
                <Form.Item
                    type="textarea"
                    label="Signature"
                    name="signature"
                    placeholder="Enter signature"
                    noMargin
                    inputSm
                    rules={[
                        {
                            required: true,
                            message: 'Signature is required',
                        },
                    ]}
                >
                    <Field />
                </Form.Item>

            </div>
        </>
    );
};
